<astral-input [control]="control" [helpText]="helpText" [type]="'number'" [inputMode]="'numeric'"></astral-input>
